import React, { useState } from "react";
import useMeasure from "react-use-measure";
import fccDatabase from "../../assets/education/fcc-database.png";
import dataEngineering from "../../assets/education/data_engineering_on_aws.png";

import { FiAward } from "react-icons/fi";
import {
    useDragControls,
    useMotionValue,
    useAnimate,
    motion,
} from "framer-motion";
// import EncryptButton from "./EncryptButton";

export const DragCloseDrawerWrapper = () => {
    const [open, setOpen] = useState(false);
    return (
        <div className=" place-content-center">
            <button
                onClick={() => setOpen(true)}
                className=" text-white transition-colors hover:text-designColor flex justify-center items-center"
            >
                See my certificates <FiAward />
            </button>

            <DragCloseDrawer open={open} setOpen={setOpen}>
                <div className="mx-auto max-w-2xl  text-neutral-400 flex-auto">
                    <h2 className="text-4xl font-bold text-neutral-200 mb-40 text-center f">
                       My Certificates
                    </h2>
                    <div className="flex flex-col justify-center items-center gap-4">
                        <img src={fccDatabase} alt="FCC Certificate" />
                        {/* <a href={`https://www.freecodecamp.org/certification/_afim_afim_/relational-database-v8`} target={"_blank"} rel={"noreferrer"}>
                        <EncryptButton TARGET_TEXT={"Verify this certificate"} />
                        </a> */}
                        <img src={dataEngineering} alt="Data Engineering AWS"/>
                    </div>
                </div>
            </DragCloseDrawer>
        </div>
    );
};

const DragCloseDrawer = ({ open, setOpen, children }) => {
    const [scope, animate] = useAnimate();
    const [drawerRef, { height }] = useMeasure();

    const y = useMotionValue(0);
    const controls = useDragControls();

    const handleClose = async () => {
        animate(scope.current, {
            opacity: [1, 0],
        });

        const yStart = typeof y.get() === "number" ? y.get() : 0;

        await animate("#drawer", {
            y: [yStart, height],
        });

        setOpen(false);
    };

    return (
        <>
            {open && (
                <motion.div
                    ref={scope}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    onClick={handleClose}
                    className="fixed inset-0 z-50 bg-[#edff20]/10 backdrop-blur-md"
                >
                    <motion.div
                        id="drawer"
                        ref={drawerRef}
                        onClick={(e) => e.stopPropagation()}
                        initial={{ y: "100%" }}
                        animate={{ y: "0%" }}
                        transition={{
                            ease: "circInOut",
                            duration: 0.9
                        }}
                        className="absolute bottom-0 h-[75vh] w-full overflow-hidden rounded-t-3xl bg-neutral-900"
                        style={{ y }}
                        drag="y"
                        dragControls={controls}
                        onDragEnd={() => {
                            if (y.get() >= 10) {
                                handleClose();
                            }
                        }}
                        dragListener={false}
                        dragConstraints={{
                            top: 0,
                            bottom: 0,
                        }}
                        dragElastic={{
                            top: 0,
                            bottom: 0.5,
                        }}
                    >
                        <div className="absolute left-0 right-0 top-0 z-10 flex justify-center bg-neutral-900 p-4">
                            <button
                                onPointerDown={(e) => {
                                    controls.start(e);
                                }}
                                className="h-2 w-14 cursor-grab touch-none rounded-full bg-neutral-700 active:cursor-grabbing"
                            ></button>
                        </div>
                        <div className="relative z-0 h-full overflow-y-scroll p-4 pt-12">
                            {children}
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </>
    );
};